import React from 'react';
import { Route, Switch } from 'react-router-dom'
import HomePage from '../pages/HomePage'
import ErrorPage from '../pages/ErrorPage'
import ProjectPage from '../pages/ProjectPage'

const Page = () => {
    return (
        <Switch >
            <Route path='/' exact component={HomePage} />
            <Route path='/projects/:id' exact component={ProjectPage} />
            <Route exact component={ErrorPage} />
        </Switch>
    )
}

export default Page;